import React from 'react';
import { Camera } from 'lucide-react';

const CircleAvatar = ({ name, size = 'medium', onClick, edit = false, imageUrl = null }) => {
    const [first, ...others] = name ? name.trim().split(/\s+/) : [];
    const initials = first ? first[0].toUpperCase() + (others.length ? others[others.length - 1][0].toUpperCase() : '') : '';
    let avatarSizeClass = 'w-11 h-11';
    if (size === 'large') avatarSizeClass = 'w-10 h-10';
    else if (size === 'extraLarge') avatarSizeClass = 'w-20 h-20 text-4xl';
    const clickableClass = onClick ? 'cursor-pointer' : '';

    return (
        <div
            className={`relative ${avatarSizeClass} flex-shrink-0 rounded-full bg-blue-500 dark:bg-blue-400 flex items-center justify-center text-white font-medium overflow-hidden ${clickableClass}`}
            onClick={onClick}
        >
            {imageUrl ? (
                <img src={imageUrl} alt={name} className="absolute inset-0 w-full h-full object-cover rounded-full" />
            ) : !edit ? (
                <span>{initials}</span>
            ) : null}
            {edit && (
                <div className="absolute inset-0 flex items-center justify-center bg-blue-500/70 dark:bg-blue-400/70">
                    <Camera size={size === 'extraLarge' ? 40 : size === 'large' ? 28 : 20} className="text-white" />
                </div>
            )}
        </div>
    );
};

export default CircleAvatar;
